import { useEffect, useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Benchmark from './components/benchmark/Benchmark';
import EsgRiskSignal from './components/esgRiskSignal/EsgRiskSignal';
import FollowingListModal from '@/ui//modals/followingListModal/FollowingListModal';
import Graph from './components/graph/Graph';
import NoFollowings from './components/NoFollowings';
import News from './components/news/News';
import SmallMenu from '@/ui//menus/secondary/small/SmallMenu';
import SelectModalButton from '@/ui//buttons/selectModalButton/SelectModalButton';
import Treemap from './components/treemap/Treemap';
import useFollowings from './hooks/useFollowings';
import useEsgRisk from './hooks/useEsgRisk';
import Virals from './components/virals/Virals';
import { SubContentsWarpper, MenuWrapper } from './DashboardStyles';
import { getFollowList, unFollow } from '@/api/followings';
import { useDispatch, useSelector } from 'react-redux';
import { addFollowingList } from '@/services/mylist/Actions';
import * as amplitude from '@amplitude/analytics-browser';
import SigninCTAModal from '@/ui//modals/signInCTAModal/SigninCTAModal';
import { Transition, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

const Dashboard = () => {
  const [t] = useTranslation('dashboard');

  const user = useSelector((state: any) => state.user.info);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (user && !Object.keys(user)) {
      if (!(Object.keys(user).length > 0)) setIsOpen(true);
    }
  }, []);

  const dispatch = useDispatch();

  const [tapIdx, setTapIdx] = useState(0);
  const [followingList, followingList_risk, corpcodes] = useFollowings();
  const [esgRiskSignalData, isRiskSignalLoading] = useEsgRisk(corpcodes);

  const [modal, setModal] = useState(false);

  const handleClick = () => setModal(!modal);
  const handleApply = async (setList) => {
    const corpCodes = followingList
      .filter((company) => {
        if (!setList.has(company)) return true;
      })
      .map((el) => el.corp_code);
    if (corpCodes.length > 0) {
      await unFollow(corpCodes.join(','));
      const newFollowing = await getFollowList();
      dispatch(addFollowingList(newFollowing.data));
    }
  };
  const handleTapChange = (i) => {
    setTapIdx(i);
    if (i === 0) amplitude.track('dashboard_graph_view');
    if (i === 0) amplitude.track('dashboard_treemap_view');
    if (i === 0) amplitude.track('dashboard_benchmark_view');
    if (i === 0) amplitude.track('dashboard_news_view');
  };

  return (
    <>
      <div className="py-12 space-y-6 md:space-y-12 max-w-6xl mx-auto">
        {followingList.length > 0 && (
          <div className="flex justify-between items-center p-4 border rounded-lg">
            <div>
              {t('My Watchlist')} ({followingList.length})
            </div>
            <SelectModalButton title={t('My Watchlist')} onClick={handleClick} />
          </div>
        )}
        <div className="space-y-6 md:space-y-12">
          {followingList.length > 0 ? (
            <>
              <EsgRiskSignal data={esgRiskSignalData} isLoading={isRiskSignalLoading} />

              <Virals corpcodes={corpcodes} />

              <SubContentsWarpper>
                <MenuWrapper>
                  <SmallMenu
                    menuList={[t('Graph'), t('Treemap'), t('Benchmark'), t('News')]}
                    activeIndex={tapIdx}
                    onClick={(i) => handleTapChange(i)}
                  />
                </MenuWrapper>
                {tapIdx === 0 ? <Graph followingList={followingList_risk} /> : null}
                {tapIdx === 1 ? <Treemap corpcodes={corpcodes} /> : null}
                {tapIdx === 2 ? <Benchmark followingList={followingList_risk} /> : null}
                {tapIdx === 3 ? <News corpcodes={corpcodes} /> : null}
              </SubContentsWarpper>
            </>
          ) : (
            <NoFollowings />
          )}
        </div>
      </div>

      <Transition appear show={modal} as={Fragment}>
        <Dialog as="div" className="relative" onClose={setModal}>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" style={{ zIndex: 1000 }} />
          </TransitionChild>

          <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 1000 }}>
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel className="w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                  <DialogTitle
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900 mb-4 hidden"
                  />

                  <FollowingListModal
                    folloiwngList={followingList}
                    onClose={() => setModal(false)}
                    onApply={handleApply}
                    sx={{}}
                  />
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
      <SigninCTAModal open={isOpen} onClose={() => setIsOpen(false)} redirection="dashboard" />
    </>
  );
};

export default Dashboard;
